export class InvalidDocumentException extends Error {}

/**
 * @throws {InvalidDocumentException}
 */

export function isInvalidDocumentError(
  error: unknown
): error is InvalidDocumentException {
  return error instanceof InvalidDocumentException;
}

export function parseDocument(document: string) {
  const parser = new DOMParser();
  const documentHtml = parser.parseFromString(document, "text/html");
  const head = documentHtml.getElementById("summary");
  const body = documentHtml.getElementById("scrollable");

  if (!head) {
    throw new InvalidDocumentException("summary tag not provided");
  }
  if (!body) {
    throw new InvalidDocumentException("scrollable tag not provided");
  }

  return {
    head,
    body,
    actions: {
      accept: null,
      reject: null,
    },
  };
}
